import script from "./OrderDetailMonitor.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderDetailMonitor.vue?vue&type=script&lang=ts&setup=true"

import "./OrderDetailMonitor.vue?vue&type=style&index=0&id=1473a23d&lang=scss"

const __exports__ = script;

export default __exports__